var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup111X(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "43px",
    viewBox: "0 0 37 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B7BB5D29-6F77-4DC4-B3FF-D94973AEB61C@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CPM-Walkthrough",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-LenderView-Project-Main-EditedProjectInfo-V2-PT4",
    transform: "translate(-1114.000000, -311.000000)",
    stroke: "#05314D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Module-/-Main-Info",
    transform: "translate(66.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lender-Cert-Status-V2",
    transform: "translate(1033.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(16.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    points: "31 11.231041 31 5.89440065 24.729154 0 0 0 0 36 20.0316494 36"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "25 0 25.0191792 6 31 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6855307,14.1054449 L29.3735657,15.6759303 C29.6974561,16.4147625 30.4598062,16.8576879 31.2580754,16.7698504 L32.9543199,16.5842079 C34.5459038,16.4104017 35.5856974,18.2207273 34.6394171,19.5208476 L33.6318268,20.9056906 C33.1574481,21.5573081 33.1574481,22.4431591 33.6318268,23.0947766 L34.6394171,24.4789967 C35.5856974,25.778494 34.5459038,27.5900655 32.9543199,27.4156363 L31.2580754,27.2299939 C30.4598062,27.1427793 29.6974561,27.5857048 29.3735657,28.3245369 L28.6855307,29.8950224 C28.0396078,31.3683259 25.96064,31.3683259 25.314717,29.8950224 L24.6260628,28.3245369 C24.3027916,27.5857048 23.5398222,27.1427793 22.7415531,27.2299939 L21.0459278,27.4156363 C19.4543439,27.5900655 18.4145504,25.778494 19.3602113,24.4789967 L20.3684209,23.0947766 C20.8427996,22.4431591 20.8427996,21.5573081 20.3684209,20.9056906 L19.3602113,19.5208476 C18.4145504,18.2207273 19.4543439,16.4104017 21.0459278,16.5842079 L22.7415531,16.7698504 C23.5398222,16.8576879 24.3027916,16.4147625 24.6260628,15.6759303 L25.314717,14.1054449 C25.96064,12.6315184 28.0396078,12.6315184 28.6855307,14.1054449 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,22.5 C31,24.4335366 29.4329268,26 27.5,26 C25.5664634,26 24,24.4335366 24,22.5 C24,20.5670732 25.5664634,19 27.5,19 C29.4329268,19 31,20.5670732 31,22.5 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-9",
    points: "21 28 21 41 26.9066148 34.109762 33 41 33 28"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup111X);
export default __webpack_public_path__ + "static/media/Group 11@1x.4560f786503c050de1c4d99d3ebcf3b1.svg";
export { ForwardRef as ReactComponent };